'use strict';
module.exports = ResponsiveNavTabs;

function ResponsiveNavTabs (bootWidth) {

  var win = $(window);
  var wind = window;
  var tabs = $('.tabs');
  var navTabsButton = $('.nav-tabs li');
  var icons = {
      plus: ' <i class="fa fa-plus-circle"></i>',
      minus: ' <i class="fa fa-minus-circle"></i>'
    };
  var activeTabIcon = $('<span/>', {id: 'active-tab-icon', html: icons.plus});
  var endeElems = $('.footer-menu ul li:last-child a');

  bootWidth = bootWidth || 992;

  tabs.tabs();

  // prime presmerovani
  // $('li.jazykove-pobyty-li a').unbind('click');
  // $('li.pracovni-pobyty-li a').unbind('click');

  /*
  if (wind.innerWidth < bootWidth)
    toggleOn();

  win.resize(toggle);

  function toggle () {
    if (wind.innerWidth < bootWidth)
      toggleOn();
    else
      toggleOff();
  }
  */
  function toggleInactiveTabs () {

    if (tabs.hasClass('expanded'))
      hideInactiveTabs.bind(this)();
    else
      showInactiveTabs.bind(this)();

    function showInactiveTabs () {
      tabs.addClass('expanded');
      $(this).siblings().slideDown();
      activeTabIcon.html(icons.minus);
    }

    function hideInactiveTabs () {
      tabs.removeClass('expanded');
      $(this).siblings().slideUp();
      activeTabIcon.html(icons.plus);
    }
  }

  function setActiveTab () {

    tabs.tabs({
      active: $(this).find('a').attr('href')
    });

    $(this).siblings().slideUp();
    activeTabIcon.html(icons.plus).appendTo($(this).find('a'));
    tabs.removeClass('expanded');
  }

  function handleNavItemClick () {

    if ($(this).hasClass('ui-state-active'))
      toggleInactiveTabs.bind(this)();
    else
      setActiveTab.bind(this)();
  }

  function handleNavItemClickEnDe (e) {
    // pro EN a DE verzi zobrazujeme talcitko airticket, kdyz na formular pristupujeme napr. z hlavniho menu nebo paticky
    if ($('body').is('.en, .de')) {
      var busTicket = $('.homepage .tabs .nav-tabs li.first');
      var airTicketLI = $('.homepage .tabs .nav-tabs li[aria-controls="form-2"]');
      var airTicketA = airTicketLI.find('> a');

      // po kliku na letenky v hlavnim menu toto menu zavreme, aby bylo lepe poznat, ze se nam otevrel novy form
      if ($('.main-nav li:last-child a').is(e.target))
          $('.header-menu').removeClass('show').addClass('hidden-xs');

      activeTabIcon.html(icons.plus).appendTo(airTicketA);
      airTicketLI.css({'display' : 'block'});
      busTicket.hide();
      tabs.removeClass('expanded');
    }

    if ($(this).hasClass('ui-state-active'))
      toggleInactiveTabs.bind(this)();
    else
      setActiveTab.bind(this)();
  }

  function toggleOn () {

    if (isMobile())
      return false;

    endeElems.bind('click', function(e) {handleNavItemClickEnDe(e)});
    activeTabIcon.appendTo($('.nav-tabs li.ui-state-active a'));
    navTabsButton.not('.ui-state-active').hide();
    navTabsButton.bind('mouseup', handleNavItemClick);
    tabs.addClass('mobile-tabs');
  }

  function toggleOff () {

    if (!isMobile())
      return false;
    activeTabIcon.remove();
    navTabsButton.unbind('mouseup').show();
    tabs.removeClass('mobile-tabs expanded');
  }

  function isMobile () {

    return tabs.hasClass('mobile-tabs');
  }
};